export enum AnswerTypes {
  TEXT = 'TEXT',
  DROP_DOWN_LIST = 'DROP_DOWN_LIST',
  MULTIPLE_SELECT_DROP_DOWN = 'MULTIPLE_SELECT_DROP_DOWN',
  RADIO_BUTTON = 'RADIO_BUTTON',
  CHECK_BOX = 'CHECK_BOX',
  DATE_PICKER = 'DATE_PICKER',
}
